const attribText = `
- Copernicus Atmosphere Modeling Service Information 2019-present
- Copernicus Sentinel data [2019] processed by Sentinel Hub
- Corine Land Cover (CLC) 2018 - Copernicus Service
- The work of [de Hoogh K, Gulliver J, et al.](http://dx.doi.org/10.1016/j.envres.2016.07.005) 2016
- [Open Street Map (C) OpenStreetMap contributors](https://www.openstreetmap.org/copyright)
- ALOS World 3D 30 meter DEM (Japan Aerospace Exploration Agency)
- Global Human Settlement Layer Population Grid 2019 (European Commission)
- Weather data from the National Oceanic and Atmospheric Administration, U.S. Department of Commerce, the Deutscher Wetterdienst and Open Weather Map ([CC BY-SA 4.0](https://creativecommons.org/licenses/by-sa/4.0/))
- European Environmental Agency
- German Umweltbundesamt
- Landesanstalt für Umwelt Baden-Württemberg
- Bayerisches Landesamt für Umwelt
- Senatsverwaltung für Umwelt, Verkehr und Klimaschutz Berlin
- Das Ministerium für Landwirtschaft, Umwelt und Klimaschutz des Landes Brandenburg
- Freie Hansestadt Bremen: Die Senatorin für Klimaschutz, Umwelt, Mobilität, Stadtentwicklung und Wohnungsbau
- Behörde für Umwelt, Klima, Energie und Agrarwirtschaft Hamburg sowie das Institut für Hygiene und Umwelt Hamburg
- Hessisches Landesamt für Naturschutz, Umwelt und Geologie
- Landesamt für Umwelt, Naturschutz und Geologie Mecklenburg-Vorpommern
- Staatliches Gewerbeaufsichtsamt Hildesheim
- Landesamt für Natur, Umwelt und Verbraucherschutz Nordrhein-Westfalen
- Landesamtes für Umwelt Rheinland-Pfalz
- Landesamt für Umwelt- und Arbeitsschutz Saarland
- Sächsisches Landesamt für Umwelt, Landwirtschaft und Geologie
- Landesamt für Umweltschutz Sachsen-Anhalt
- Landesamt für Landwirtschaft, Umwelt und ländliche Räume Schleswig-Holstein
- Thüringer Landesamt für Umwelt, Bergbau und Naturschutz
- Swiss Federal Office for the Environment (FOEN/BAFU)
- Swiss National Air Pollution Monitoring Network (NABEL)
- Bern Department for the Environment
- Energie, Landwirtschaft und Umwelt Staat Freiburg 
- Service de l'air, du bruit et des rayonnements non ionisants République et Canton de Genève 
- Luftqualitaet Nordwestschweiz
- OSTLUFT: die Luftqualitätsüberwachung der Ostschweizer Kantone
- Swiss department for statistics
- Amt für Luft, Klima und Erneuerbare Energien Kanton Tessin
- Direction de l'environnement industriel, urbain et rural Etat de Vaud
- Dienststelle für Umwelt Kanton Wallis
- Zentralschweizer Umweltdirektionen
- Gesundheits- und Umweltdepartement Stadt Zurich

Our air quality index uses the approach from the [Common Air Quality Index](https://www.airqualitynow.eu/about_indices_definition.php). The COPD and Asthma indexes are based on the work of Zhang et al.[1].

[1] [Zhang, S., Li, G., Tian, L., Guo, Q., & Pan, X. (2016). Short-term exposure to air pollution and morbidity of COPD and asthma in East Asian area: A systematic review and meta-analysis. _Environmental research_, _148_, 15–23.](https://doi.org/10.1016/j.envres.2016.03.008)
`;

export default attribText;
